import React from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore, useTranslation, userInfoStore, wageringStore } from '@pascal/pascal-core';
import { oddStore } from '../../../store/oddStore';
import { translationKeys } from '../../../enums/translations';

const BetButton = observer(
  ({
    betId,
    itemId,
    freeBetId,
    freeBetMinOdd,
    betAmount,
    winAmount,
    isDisabled,
    sendCashOut,
    isBetAccepted,
    isNextRoundBet,
    oddCurrentValue,
    handleOpenPopUp,
    isMinOddNull,
    setBetAmountPopupId,
  }) => {
    const t = useTranslation();
    const { currencySymbolOrCode } = userInfoStore;
    const { activeFreeBet } = freeBetStore;
    const { oddData } = oddStore;
    const { partnerWageringOdd } = wageringStore;
    const { FREE_BET, MIN_ODD } = translationKeys;
    const { extraFreeBetData } = freeBetStore;

    // if (!itemId) {
    //   console.log({
    //     isMinOddNull: toJS(isMinOddNull),
    //     freeBetId: toJS(freeBetId),
    //     freeBetMinOdd: toJS(freeBetMinOdd),
    //   });
    // }

    // const isShowMinOdd = () => {
    //   // return (
    //   //   (((activeFreeBet?.id && !isBetAccepted && !betId) || freeBetId) &&
    //   //     !(activeFreeBet?.isMinOddNull || isMinOddNull)) ||
    //   //   partnerWageringOdd
    //   // );
    //
    //   if (!itemId) {
    //     console.log({
    //       isMinOddNull: toJS(isMinOddNull),
    //       freeBetId: toJS(freeBetId),
    //       activeFreeBet: toJS(activeFreeBet),
    //     });
    //   }
    //   if (!isMinOddNull && freeBetId) {
    //     return false;
    //   }
    //
    //   if (isBetAccepted || betId || (activeFreeBet?.id && !activeFreeBet?.isMinOddNull)) {
    //     return false;
    //   }
    //
    //   return true;
    // };

    return (
      <button
        type='button'
        className={`c-m-bets-btn type-${betId ? 2 : 1} ${
          ((betId && freeBetId) || partnerWageringOdd) &&
          (freeBetMinOdd || partnerWageringOdd) > oddData[itemId]
            ? 'inactive'
            : ''
        }`}
        onClick={(event) => {
          return isBetAccepted && oddCurrentValue
            ? sendCashOut(betId)
            : !betId && handleOpenPopUp(event, setBetAmountPopupId);
        }}
      >
        {isBetAccepted ? (
          <>
            <span className='c-m-bets-btn-txt'>
              {extraFreeBetData[itemId].isShowPopUp
                ? extraFreeBetData[itemId].maxPayout
                : oddCurrentValue
                ? (oddCurrentValue * betAmount).toFixed(2)
                : betAmount}{' '}
              {currencySymbolOrCode}
            </span>
            <span className='c-m-bets-btn-txt'>{t('CASH_OUT')}</span>
          </>
        ) : (
          <>
            {betId ? (
              <span className='c-m-bets-btn-txt'>
                {winAmount || 0} {currencySymbolOrCode}
              </span>
            ) : (
              <span className='c-m-bets-btn-txt'>
                {betAmount
                  ? `${betAmount} ${currencySymbolOrCode}`
                  : isDisabled || isNextRoundBet
                  ? t('BET_FOR_NEXT')
                  : activeFreeBet?.id || freeBetId
                  ? `${t(FREE_BET)} ${activeFreeBet.remainingCount}`
                  : t('BET')}
              </span>
            )}
          </>
        )}
        {(((activeFreeBet?.id && !isBetAccepted && !betId) || freeBetId) &&
          !(activeFreeBet?.isMinOddNull || isMinOddNull)) ||
        partnerWageringOdd ? (
          <p className='c-m-bets-min-odd-txt'>
            {t(MIN_ODD)}:
            <span className='c-m-bets-min-odd-num'>
              x{freeBetMinOdd || freeBetStore.activeFreeBet?.minOdd || partnerWageringOdd}
            </span>
          </p>
        ) : (
          <></>
        )}
        <span className='c-m-bets-btn-hover' />
        <span className='c-m-bets-btn-line' />
      </button>
    );
  }
);

export default BetButton;
